export default "__VITE_ASSET__BB6RF1QR__"